import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'miq-chat-prompts-panel',
  templateUrl: './chat-prompts-panel.component.html',
  styleUrls: ['./chat-prompts-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatPromptsPanelComponent {
  @Input() defaultPrompts: string[] = [];
  @Input() windowSizeIncreased!: boolean;
  @Output()
  emitToggleWindowSize = new EventEmitter<boolean>();
  @Output() emitPromptSelected = new EventEmitter<string>();
  @Output() emitStartNewSession = new EventEmitter<void>();

  handlePromptClick(prompt: string): void {
    // Handle the prompt click event here
    this.emitPromptSelected.emit(prompt);
  }

  toggleWindowSize(event: boolean): void {
    this.emitToggleWindowSize.emit(event);
  }

  startNewSession(): void {
    // Logic to start a new session
    this.emitStartNewSession.emit();
  }
}
